import { Component, Inject, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-broken-page-dialog',
  templateUrl: './broken-page-dialog.component.html',
  styleUrls: ['./broken-page-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class BrokenPageDialogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    @Inject(DOCUMENT) private _document: Document,
    private readonly router: Router,
    private dialogRef: MatDialogRef<BrokenPageDialogComponent>,
  ) {}

  ngOnInit() {}

  public closeDialog() {
    this.dialogRef.close();
  }

  public reloadCurrentPage() {
    this._document.defaultView.location.reload();
  }

  public goToStartPage() {
    this.router.navigate(['/']);
    this.dialogRef.close();
  }
}
